import { render, staticRenderFns } from "./WithdrawalID.vue?vue&type=template&id=51f652e0&"
import script from "./WithdrawalID.vue?vue&type=script&lang=js&"
export * from "./WithdrawalID.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalID.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports